import _ from 'lodash'

/**
 * Maps properties from the source object to the target object based on the keys present in the target.
 * Only the properties that exist in the target object will be considered; any additional properties in the source object are ignored.
 * This function returns a new object to avoid mutating the original target.
 *
 * @param {Partial<T>} source The object from which to copy properties, can have additional keys not in T.
 * @param {T} target The object defining the structure and keys for the mapping, with type T.
 * @returns {T} A new object of type T with properties from the source where they exist; retains target properties where source does not have them.
 */
export const mapToObject = <T>(source: Partial<T>, target: T): T => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: Record<string, any> = {}
  
  for (const key in target) {
    if (source.hasOwnProperty(key))
      result[key] = _.cloneDeep(source[key])
    else
      result[key] = _.cloneDeep(target[key])
  }

  return result as T
}
